module.exports = __webpack_public_path__ + "img/144.6679a85e.jpg";